import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonService } from '../../services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-privacy-legal-dialog',
  templateUrl: './privacy-legal-dialog.component.html',
  styleUrls: ['./privacy-legal-dialog.component.scss']
})
export class PrivacyLegalDialogComponent {
  dialogTitle: string = '';
  dialogContent: SafeHtml = 'Loading...'; // Sanitized HTML content
  isLoading: boolean = true; // Show loader while fetching data

  constructor(
    private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    private readonly spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PrivacyLegalDialogComponent>,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {
    this.dialogTitle = data.type === 'privacy' ? 'Privacy Policy' : 'Legal';
  }

  ngOnInit(): void {
    this.fetchContent();
  }

  fetchContent(): void {
    this.spinner.show(); // Show loader while fetching
    const api = this.api.apiUrl.Login.PrivacyPolicyAndLegal;

    this.commonService.doGet(api).subscribe({
      next: (response: any) => {
        if (response.success && response.data) {
          // Fetch and sanitize content based on the dialog type ('privacy' or 'legal')
          const content =
            this.data.type === 'privacy'
              ? response.data.privacyPolicy
              : response.data.legal;
          this.dialogContent = this.sanitizer.bypassSecurityTrustHtml(content || 'No content available.');
          setTimeout(() => {
            const divs = document.querySelectorAll('.privacy-policy');

            divs.forEach(el => el.addEventListener('click', event => {
              this.openPrivacyPolicies()
            }));
          }, 2000);

        } else {
          this.dialogContent = this.sanitizer.bypassSecurityTrustHtml('Failed to load content.');
        }

        this.isLoading = false; // Hide loading spinner
        this.spinner.hide();
      },
      error: (error: any) => {
        console.error('Error fetching privacy policy:', error);
        this.dialogContent = this.sanitizer.bypassSecurityTrustHtml('An error occurred. Please try again later.');
        this.isLoading = false; // Hide loading spinner
        this.spinner.hide();
      },
    });
  }


  closeDialog(): void {
    this.dialogRef.close();
  }
  openPrivacyPolicies(type : string = 'privacy'){


    const dialogConfig = {
      width: '800px',
      data: { type }, // Pass the type to the dialog
    };
    this.dialog.open(PrivacyLegalDialogComponent, dialogConfig);
  }
}
